const columns = [
  {
    name: 'Role',
    selector: (row) => row.name,
  },
  {
    name: 'Delete',
    selector: (row) => row.actions,
  },
]

export default columns
